<template>
  <div>
    <div class="details-banner" v-if="!bannerImg"></div>
    <a :href="!!bannerPath && bannerPath">
      <img :src="bannerImg" style="width: 100%;margin-top: 64px" v-if='sourceType === "img" && bannerImg' />
      <video id="" autoplay muted loop preload="auto" style="z-index: 200; width: 100%; height: auto;"
        v-if='sourceType === "video" && video'>
        <source type="video/mp4" :src="video" />
      </video>
    </a>

    <div class="partner-main">
      <div class="partner-container">
        <!-- <div v-if="guidance.length"> -->
        <div class="partner-container-title">指导单位</div>
        <el-row type="flex" justify="center">
          <el-col v-for="(child, childIndex) in guidance" :key="childIndex" :span="6" class="img-box"
            style="margin-bottom: 50px">
            <img class="partner-logo" :src="child.unitLogo" @click="handleImgClick(child)" />
          </el-col>
        </el-row>
        <!-- </div> -->
        <div v-if="coBuilding.length">
          <div class="partner-container-title">共建单位</div>

          <el-row type="flex" justify="center" :style="{ flexWrap: 'wrap' }">
            <el-col v-for="(child, childIndex) in coBuilding" :key="childIndex" :span="6" class="img-box">
              <img class="partner-logo" :src="child.unitLogo" @click="handleImgClick(child)" />
            </el-col>
          </el-row>
        </div>


        <div class="partner-container-title">共建历程</div>
        <div class="timeList">
          <div class="timeItem" :class="(i + 1) % 2 == 0 ? 'right' : 'left'" v-for="(v, i) in timeList" :key="v.id">
            <div class="time">{{ v.timelineContent ? v.timelineContent.slice(0, 10) : '进行中' }}</div>
            <div class="text">{{ v.title }}</div>
            <img :src="v.image" alt="" class="img">
            <div class="timeDot" :class="i === 0 ? 'triangle' : ''"></div>
            <div class="timeLine"></div>
          </div>

        </div>
        <div v-if="principle.length">
          <div class="partner-container-title">共建原则</div>
          <div class="principleList">
            <div class="principleItem" v-for="(v, i) in principle" :key="v.id">
              <img :src="v.image" alt="" class="img">
              <div class="text">{{ v.principleContent }}</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { listBanner, listPartner, listTime, listPrinciple } from '@/api'
export default {
  name: "EcoPartner",
  data () {
    return {
      guidance: [],
      coBuilding: [],
      sourceType: 'img',
      bannerImg: '',
      timeList: [],
      active: 0,
      principle: [],
      bannerPath: ''
    }
  },
  created () {
    // 获取banner数据
    this.getBanner()
    // 获取列表数据
    this.getData()
    // 获取时间轴数据
    this.getTime()
    // 共建原则数据
    this.getPrinciple()
  },
  methods: {
    async getPrinciple () {
      const res = await listPrinciple()
      this.principle = res.rows
    },
    async getTime () {
      const res = await listTime({ useFlag: '1' })
      this.timeList = res.rows
    },
    async getData () {
      const res = await listPartner()
      const guidance = []
      const coBuilding = []
      res.rows.forEach(v => {
        if (v.unitType === 'GJ_UNIT') {
          coBuilding.push(v)
        } else if (v.unitType === 'ZD_UNIT') {
          guidance.push(v)
        }
      })
      this.guidance = guidance
      this.coBuilding = coBuilding
    },
    async getBanner () {
      const res = await listBanner({ bannerPosition: 'STHB_BANNER' })

      const data = res.rows.find(v => (v.bannerImg && v.sourceType == 'img') || (v.video && v.sourceType == 'video'))
      if (!data) return
      this.sourceType = data.sourceType
      this.bannerImg = data.bannerImg
      this.video = data.video
      this.bannerPath = data.link
    },
    handleImgClick (item) {
      if (item.unitLink) window.open(item.unitLink)
    },
    go (val) {
      this.$router.push({ path: '/EcosystemJoint', query: { name: val } })
    },
  }
}
</script>

<style lang="scss" scoped>
.principleList {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .principleItem {
    width: 2.8rem;
    height: 3.5rem;
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 .1rem;
    margin-bottom: 0.1rem;

    .img {
      width: .7rem;
      height: .7rem;
      margin-bottom: .8rem;
    }

    .text {
      font-size: .16rem;
      text-align: center;
      padding: 0 .4rem;
      overflow-y: auto;
    }
  }
}

.timeList {

  margin: 0 auto;
  width: 80%;

  .timeItem {

    display: flex;
    flex-direction: column;
    align-items: center;
    width: 50%;
    position: relative;


    .timeLine {
      position: absolute;
      width: .05rem;
      background-color: #E50009;
      top: 0;
      bottom: 0;

    }

    .timeDot {
      width: .2rem;
      height: .2rem;
      border-radius: 50%;
      position: absolute;
      background-color: #E50009;
      top: 0;
    }

    &.left {
      align-items: flex-end;
      padding-right: .4rem;
      box-sizing: border-box;

      .timeLine {
        right: -.025rem;
      }

      .timeDot {
        right: -.1rem;
      }
    }

    &.right {
      align-items: flex-start;
      left: 50%;
      padding-left: .4rem;
      box-sizing: border-box;

      .timeLine {
        left: -.025rem;
      }

      .timeDot {
        left: -.1rem;
      }
    }

    .triangle {
      width: 0;
      height: 0;
      border-bottom: .2rem solid #e50009;
      border-right: .2rem solid transparent;
      border-left: .2rem solid transparent;
      border-radius: 0;
      background-color: transparent;
      right: -.2rem !important;
      top: -.2rem;
    }


    .time {
      font-size: .35rem;
      font-weight: 700;
      color: #e50009;
      /* line-height: .8rem; */
      margin-bottom: .12rem;
      margin-top: -.15rem;
    }

    .text {
      font-size: .2rem;
      margin-bottom: .15rem;
    }

    .img {
      width: 4.12rem;
      height: 2.5rem
    }
  }
}

.partner-main {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  text-align: center;
  width: 100%;

  .partner-container {
    width: 75%;
    margin-bottom: 40px;

    .partner-container-title {
      font-size: 32px;
      margin: 60px 0;
    }

    .img-box {
      height: 100px;
      padding: 25px;
      overflow: hidden;

      img {
        height: 100%;
      }
    }

    .partner-logo {
      width: 100%;
      transition: all 0.5s;
      cursor: pointer;
    }

    .partner-logo:hover {
      transform: scale(1.2);
    }
  }
}

.product-head {
  // margin-top: 20px;
  padding-left: 12.5%;
  // justify-content: space-between;
  // font-size: 18px;
  // font-weight: 500;
  // color: #333;
  // cursor: pointer;
  // white-space: nowrap;
  // margin-top: 10px;
  // height: 40px;
  // line-height: 40px;
}

.about-head {
  width: 75%;
  margin-top: 50px;

  .about-head-title {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    cursor: pointer;
  }

  .active {
    color: #E50009;
  }
}

@media screen and (max-width: 400px) {
  .product-head {
    display: block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EcoPartner.vue